import { Controller } from "@hotwired/stimulus"

// Swaps a display element for an edit form and back. The form's
// submit response (e.g. a Turbo Stream re-render) closes it naturally.
export default class extends Controller {
  static targets = ["display", "form"]

  show(event) {
    event.preventDefault()
    this.displayTarget.classList.add("is-hidden")
    this.formTarget.classList.remove("is-hidden")
    this.formTarget.querySelector("input[type='text']")?.focus()
  }

  hide(event) {
    event.preventDefault()
    this.formTarget.classList.add("is-hidden")
    this.displayTarget.classList.remove("is-hidden")
  }
}
